module.exports = {
  CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST: 'CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_REQUEST',
  CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_SUCCESS: 'CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_SUCCESS',
  CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_FAILURE: 'CENTER_INITIATED_REPATRIATIONS_TRANSACTIONS_CREATE_FAILURE',
};
